import React from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const ExitAttraction = (props) => {
  const history = useHistory();
  return (
    <Modal
      className="delete-popup"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
        <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>No changes will be saved. Are you sure you want to exit?</h4>
        <div className="button-row">
          <button className="cancel-btn"  onClick={props.onHide}>
            Cancel
          </button>
          <div
            onClick={() => {
                history.push("/attractions");
              }}
            className="button"
            style={{ cursor: 'pointer' }}
          >
            Yes
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Header closeButton></Modal.Header> */}
      {/* <Modal.Body>
        <div className="success-body">
          <h2>No changes will be saved. Are you sure you want to exit?</h2>

          <div className="submit-row">
            <div className="col">
              <button onClick={props.onHide} className="secondary-button">
                Cancel
              </button>
            </div>
            <div className="col">
              <button
                className="primary-button"
                onClick={() => {
                  history.push("/attractions");
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </Modal.Body> */}
    </Modal>
  );
};

export default ExitAttraction;
